import Button from 'core/display/buttons/Button'
import Image from 'core/display/Image'

export default class ImageButton {
  constructor(data) {
    return new Button(data, new Image(data))
  }
}
